export type CategoryInputModel = {
  id: string,
  title: string,
  languageId: string,
  link: string
}

export type CategoryOutputModel = {
  id: string;
  name: string;
  code: string;
  picture: string | null;
  alt: string | null;
  description: string | null;
  isProduct: boolean;
  slug: string[];
  // title: string | null;
  pageTitle: string | null;
  metaDescription: string | null;
  timePublication: string | null;
  status: boolean;
};

export type VideoCategoryOutputModel = {
  id: string;
  languageId: string;
  title: string;
  link: string;
  code: string;
  status: string;
  type: string;
};

export enum CategoryStatus {
  PUBLISH = "publish",
  UNPUBLISH = "unpublish",
}